export default {
  lang: {
    confirm: {
      title: 'Bạn có xác nhận rằng bạn muốn xóa? Sẽ không thể khôi phục sau khi xóa',
      okText: 'Xóa',
      cancelText: 'Hủy bỏ',
    },
  },
};
